module.exports = __webpack_public_path__ + "static/media/keyman-database-logo.53405287.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keyman-database-logo.png
// module id = 1281
// module chunks = 1